import View from './view';

const EVENTS = {
	'file:change': 'fileChange',
	change: 'change',
	input: 'change',
	focus: 'focus',
	blur: 'blur',
	mouseover: 'hover',
	mouseout: 'out',
	invalid: 'invalid',
};

export default class Input extends View {
	constructor(options) {
		super(options);
		this.oldValue = null;
		this.enabled = true;
	}

	initEvents() {
		super.initEvents(this);

		for (const k of Object.keys(EVENTS)) {
			const keys = k.split(':');
			let key = k;
			let field;
			if (keys[1]) {
				key = keys[1];
				field = keys[0];
				if (this.getType() !== field) {
					continue;
				}
			}
			const eventName = EVENTS[k];

			this.el.addEventListener(
				key,
				this.onEvent.bind(this, eventName, key),
				false
			);
		}

		this.events.on('blur', () => {
			if (this.getValue()) {
				this.events.emit('interacted');
			}
		});

		this.events.on('change', () => {
			this.oldValue = this.getValue();
			if (this.el.validity && this.el.validity.valid) {
				this.events.emit('valid');
			} else {
				this.events.emit('invalid');
			}
		});
	}

	onEvent(eventName, key) {
		if (!this.enabled) {
			return;
		}

		if (key === 'keyup') {
			if (!this.hasChangeValue()) {
				return;
			}
			this.oldValue = this.getValue();
		}

		if (eventName === 'change' && key === 'change') {
			eventName = 'blur'; // confirm with enter
		}
		if (eventName === 'change' && this.oldValue === this.getValue() && key !== 'change') {
			return;
		}

		this.events.emit(eventName, this.el.value);
	}

	getValue() {
		if (this.getType() === 'textarea') {
			this.value = this.el.innerHTML;
		} else if (this.getType() === 'checkbox') {
			this.value = !!this.el.getAttribute('checked');
		} else {
			this.value = this.el.value;
		}

		if (this.value === '') {
			this.value = null;
		}
		return this.value;
	}

	setValue(value) {
		if (this.getType() === 'textarea') {
			this.el.innerHTML = value;
		} else if (this.getType() === 'checkbox') {
			this.el.checked = !!value;
		} else {
			this.el.value = value;
		}
		this.value = value;
		this.oldValue = this.value;
	}

	hasChangeValue() {
		return this.getValue() !== this.oldValue;
	}

	getType() {
		if (this.type) {
			return this.type;
		}

		if (this.el.tagName === 'TEXTAREA') {
			this.type = 'textarea';
		} else if (this.el.tagName === 'SELECT') {
			this.type = 'select';
		} else {
			this.type = this.el.getAttribute('type');
		}

		return this.type;
	}

	focus() {
		this.el.focus();
	}

	enable() {
		this.enabled = true;
	}

	disable() {
		this.enabled = false;
	}

	getName() {
		return this.el.getAttribute('name');
	}

	empty() {
		this.setValue('');
	}
}
